import React from "react";
import { useNavigate } from "react-router-dom";
import { useDisplayConfig } from "../context/DisplayConfigContext";
import "./LandingPage.css";

export default function LandingPage() {
  const { displayConfigs } = useDisplayConfig();
  const navigate = useNavigate();

  return (
    <div className="landing-container">
      <h1 className="landing-title">Kitchen Display</h1>
      <div className="landing-grid">
        {displayConfigs === null && (
          <p className="landing-loading">Loading displays…</p>
        )}
        {displayConfigs !== null && displayConfigs.length === 0 && (
          <p className="landing-empty">
            No displays configured. Open Settings on any display to add one.
          </p>
        )}
        {displayConfigs?.map((display) => (
          <button
            key={display.id}
            className="landing-card"
            onClick={() => navigate(`/active/${display.id}`)}
          >
            <div className="landing-card-name">{display.name}</div>
            <div className="landing-card-meta">
              {display.showAll
                ? "All categories"
                : `${display.categories.length} categor${display.categories.length === 1 ? "y" : "ies"}`}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
